// const firebaseConfig = {
//   apiKey: "AIzaSyAKHyJUMaM-mpjbOPlJf6UvOtEAqTydEQs",
//   authDomain: "test23-d168c.firebaseapp.com",
//   projectId: "test23-d168c",
//   storageBucket: "test23-d168c.appspot.com",
//   messagingSenderId: "651687643316",
//   appId: "1:651687643316:web:70598377e176d520bc6fe1"
// };

const firebaseConfig = {
  apiKey: "AIzaSyAnbIoW485C2aaU58Bfyd9XZiLDjtnn0WU",
  authDomain: "shoppingadda-6669a.firebaseapp.com",
  projectId: "shoppingadda-6669a",
  storageBucket: "shoppingadda-6669a.appspot.com",
  messagingSenderId: "459244898060",
  appId: "1:459244898060:web:2376c987f8c2a5f307eb29"
};
export default firebaseConfig;